import { isDesktop, isMobile, isTablet } from 'react-device-detect';

var mult = isMobile || isTablet ? 2 : 1;

export const reel_column_1 = {
	name: 'reel_column_1',
	components: [
		{
			name: 'reel_1_bg',
			type: 'Sprite',
			position: { x: 0, y: 25 },
			img: 'major_2_bg',
			scale: { x: 0.88 * mult, y: 0.88 * mult }
		},
		{
			name: 'reel_1',
			type: 'Sprite',
			position: { x: 50, y: 86 },
			img: 'starship00.png',
			scale: { x: 0.7 * mult, y: 0.7 * mult }
		},
		isDesktop && {
			name: 'reel_1_border',
			type: 'AnimatedSprite',
			position: { x: 20, y: 230 },
			animation: {
				pattern: 'bgshadowslow_000$.png',
				start: 0,
				end: 59,
				speed: 0.5,
				precision: 2,
				loop: true,
				scale: {
					x: 1 * mult,
					y: 1 * mult
				}
			}
		},
		{
			name: 'reel_1_bg',
			type: 'Sprite',
			position: { x: 20, y: 230 },
			img: 'major_4_bg',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		},
		{
			name: 'reel_2',
			type: 'AnimatedSprite',
			position: { x: 35, y: 258 },
			animation: {
				pattern: 'helmet$.png',
				start: 6,
				end: 57,
				speed: 0.5,
				precision: 2,
				loop: true,
				scale: {
					x: 0.8 * mult,
					y: 0.8 * mult
				}
			}
		},

		{
			name: 'reel_3_bg',
			type: 'Sprite',
			position: { x: 10, y: 405 },
			img: 'minor_1_bg',
			scale: { x: 0.84 * mult, y: 0.84 * mult }
		},
		{
			name: 'reel_3',
			type: 'Sprite',
			position: { x: 45, y: 440 },
			img: 'A00.png',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		}
	]
};

export const reel_column_2 = {
	name: 'reel_column_2',

	components: [
		{
			name: 'reel_4_bg',
			type: 'Sprite',
			position: { x: 185, y: 35 },
			img: 'major_3_bg',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		},
		{
			name: 'reel_4',
			type: 'Sprite',
			position: { x: 215, y: 75 },
			img: 'asteroid00.png',
			scale: { x: 0.75 * mult, y: 0.75 * mult }
		},
		isDesktop && {
			name: 'reel_5_border',
			type: 'AnimatedSprite',
			position: { x: 190, y: 230 },
			animation: {
				pattern: 'bgshadowslow_000$.png',
				start: 0,
				end: 59,
				speed: 0.5,
				precision: 2,
				loop: true,
				scale: {
					x: 1 * mult,
					y: 1 * mult
				}
			}
		},
		{
			name: 'reel_6_bg',
			type: 'Sprite',
			position: { x: 190, y: 230 },
			img: 'major_4_bg',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		},
		{
			name: 'reel_5',
			type: 'AnimatedSprite',
			position: { x: 220, y: 258 },
			animation: {
				pattern: 'helmet$.png',
				start: 6,
				end: 57,
				speed: 0.5,
				precision: 2,
				loop: true,
				scale: {
					x: 0.8 * mult,
					y: 0.8 * mult
				}
			}
		},

		{
			name: 'reel_6_bg',
			type: 'Sprite',
			position: { x: 200, y: 405 },
			img: 'minor_3_bg',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		},
		{
			name: 'reel_6',
			type: 'Sprite',
			position: { x: 230, y: 440 },
			img: 'Q00.png',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		}
	]
};

export const reel_column_3 = {
	name: 'reel_column_3',

	components: [
		{
			name: 'reel_7_bg',
			type: 'Sprite',
			position: { x: 365, y: 35 },
			img: 'minor_2_bg',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		},
		{
			name: 'reel_7',
			type: 'Sprite',
			position: { x: 395, y: 65 },
			img: 'J00.png',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		},
		{
			name: 'reel_6_bg',
			type: 'Sprite',
			position: { x: 370, y: 230 },
			img: 'major_4_bg',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		},
		isDesktop && {
			name: 'reel_8_border',
			type: 'AnimatedSprite',
			position: { x: 370, y: 230 },
			animation: {
				pattern: 'bgshadowslow_000$.png',
				start: 0,
				end: 59,
				speed: 0.5,
				precision: 2,
				loop: true,
				scale: {
					x: 1 * mult,
					y: 1 * mult
				}
			}
		},
		{
			name: 'reel_8',
			type: 'AnimatedSprite',
			position: { x: 400, y: 258 },
			animation: {
				pattern: 'helmet$.png',
				start: 6,
				end: 57,
				speed: 0.5,
				precision: 2,
				loop: true,
				scale: {
					x: 0.8 * mult,
					y: 0.8 * mult
				}
			}
		},

		{
			name: 'reel_9_bg',
			type: 'Sprite',
			position: { x: 365, y: 405 },
			img: 'minor_5_bg',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		},
		{
			name: 'reel_9',
			type: 'Sprite',
			position: { x: 400, y: 440 },
			img: 'ten00.png',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		}
	]
};

export const reel_column_4 = {
	name: 'reel_column_4',

	components: [
		{
			name: 'reel_10_bg',
			type: 'Sprite',
			position: { x: 540, y: 35 },
			img: 'minor_1_bg',
			scale: { x: 0.84 * mult, y: 0.84 * mult }
		},
		{
			name: 'reel_10',
			type: 'Sprite',
			position: { x: 575, y: 65 },
			img: 'A00.png',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		},
		{
			name: 'reel_11',
			type: 'AnimatedSprite',
			position: { x: 565, y: 250 },
			animation: {
				pattern: 'Wildflames_000$.png',
				start: 0,
				end: 34,
				speed: 0.5,
				precision: 2,
				loop: true,
				scale: {
					x: 0.7 * mult,
					y: 0.7 * mult
				}
			}
		},
		{
			name: 'reel_11_icon',
			type: 'AnimatedSprite',
			position: { x: 570, y: 250 },
			animation: {
				pattern: 'Blaster$.png',
				start: 0,
				end: 58,
				speed: 0.5,
				precision: 2,
				loop: true,
				scale: {
					x: 0.8 * mult,
					y: 0.8 * mult
				}
			}
		},
		{
			name: 'reel_11_text',
			position: { x: 675, y: 405 },
			type: 'Sprite',
			img: 'reel_wild_text',
			scale: {
				x: 0.7 * mult,
				y: 0.7 * mult
			}
		},

		// {
		//   name: "reel_11_bg",
		//   type: "Sprite",
		//   img: "major_5_bg",
		//   position: { x: 550, y: 230 },
		//   scale: { x: 0.8 * mult, y: 0.8 * mult },
		// },
		// {
		//   name: "reel_11",
		//   type: "Sprite",
		//   img: "telescope00.png",
		//   position: { x: 590, y: 270 },
		//   scale: { x: 0.75 * mult, y: 0.75 * mult },
		// },
		{
			name: 'reel_12_bg',
			type: 'Sprite',
			position: { x: 545, y: 400 },
			img: 'minor_4_bg',
			scale: { x: 0.85 * mult, y: 0.85 * mult }
		},
		{
			name: 'reel_12',
			type: 'Sprite',
			position: { x: 580, y: 445 },
			img: 'J00.png',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		}
	]
};

export const reel_column_5 = {
	name: 'reel_column_5',

	components: [
		{
			name: 'reel_13_bg',
			type: 'Sprite',
			position: { x: 720, y: 34 },
			img: 'major_5_bg',
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		},
		{
			name: 'reel_13',
			type: 'Sprite',
			position: { x: 760, y: 69 },
			img: 'telescope00.png',
			scale: { x: 0.75 * mult, y: 0.75 * mult }
		},
		{
			name: 'reel_14_bg',
			type: 'Sprite',
			img: 'minor_2_bg',
			position: { x: 720, y: 224 },
			scale: { x: 0.85 * mult, y: 0.85 * mult }
		},
		{
			name: 'reel_14',
			type: 'Sprite',
			img: 'K00.png',
			position: { x: 760, y: 265 },
			scale: { x: 0.8 * mult, y: 0.8 * mult }
		},
		{
			name: 'reel_15_bg',
			type: 'Sprite',
			position: { x: 710, y: 390 },
			img: 'major_2_bg',
			scale: { x: 0.9 * mult, y: 0.9 * mult }
		},
		{
			name: 'reel_15',
			type: 'Sprite',
			position: { x: 770, y: 465 },
			img: 'starship00.png',
			scale: { x: 0.7 * mult, y: 0.7 * mult }
		}
	]
};
